import types from './types';

export default (
  state = {
    isFetchingGrouoList: false,
    groupList: [],
    groupListError: "",

    isFetchingGroupCard: false,
    groupCard: null,
    groupCardError: "",

    isFetchingGroupSystem: false,
    groupSystem: null,
    groupSystemError: "",

    isFetchingGroupMain: false,
    groupMain: null,
    groupMainError: "",

    isFetchingGroupStudents: false,
    groupStudents: [],
    groupStudentsError: "",

    isFetchingGroupPlan: false,
    groupPlan: null,
    groupPlanError: "",

    isFetchingGroupProgramInfo: false,
    groupProgramInfo: null,
    groupProgramInfoError: "",

    isCreatingGroup: false,
    createdGroup: null,
    groupCreationError: "",

    isCreatingStudent: false,
    createdStudent: null,
    studentCreationError: "",

    isAddingStudent: false,
    addedStudent: null,
    studentAdditionError: "",

    isDeletingStudent: false,
    deletedStudent: null,
    studentDeletingError: "",

    isMovingStudent: false,
    movedStudent: null,
	studentMovingError: "",

    isFetchingPlanList: false,
    planList: [],
    planListError: "",

    isFetchingTeacherList: false,
    teacherList: [],
    teacherListError: "",

    isUploadingFile: false,
    uploadedFile: null,
    fileUploadError: "",

    isCheckingFile: false,
    checkedFile: null,
    fileCheckingError: "",

    isExecutingFile: false,
    executedFile: null,
	fileExecutingError: "",

	isUpdatingGroup: false,
	updatingGroup: null,
	updatingGroupError: "",

    isDeletingGroup: false,
    deletedGroup: null,
    deleteGroupError: "",

	isFetchingRequestGroupList: false,
	requestGroupList: null,
	requestGroupListError: "",

    isChangingGroupStatus: false,
    changedGroupStatus: null,
    changingGroupStatusError: "",
  }, action
) => {
  switch (action.type) {
    case types.GET_GROUP_CARD_REQUEST:
      return {
        ...state,
        isFetchingGroupCard: action.isFetchingGroupCard
      };
    case types.GET_GROUP_CARD_COMPLETED:
      return {
        ...state,
        isFetchingGroupCard: action.isFetchingGroupCard,
        groupCard: action.groupCard
      };
    case types.GET_GROUP_CARD_ERROR:
      return {
        ...state,
        isFetchingGroupCard: action.isFetchingGroupCard,
        groupCardError: action.groupCardError
      };

    case types.GET_GROUP_SYSTEM_INFO_REQUEST:
      return {
        ...state,
        isFetchingGroupSystem: action.isFetchingGroupSystem
      };
    case types.GET_GROUP_SYSTEM_INFO_COMPLETED:
      return {
        ...state,
        isFetchingGroupSystem: action.isFetchingGroupSystem,
        groupSystem: action.groupSystem
      };
    case types.GET_GROUP_SYSTEM_INFO_ERROR:
      return {
        ...state,
        isFetchingGroupSystem: action.isFetchingGroupSystem,
        groupSystemError: action.groupSystemError
      };

    case types.GET_GROUP_MAIN_REQUEST:
      return {
        ...state,
        isFetchingGroupMain: action.isFetchingGroupMain
      };
    case types.GET_GROUP_MAIN_COMPLETED:
      return {
        ...state,
        isFetchingGroupMain: action.isFetchingGroupMain,
        groupMain: action.groupMain
      };
    case types.GET_GROUP_MAIN_ERROR:
      return {
        ...state,
        isFetchingGroupMain: action.isFetchingGroupMain,
        groupMainError: action.groupMainError
      };

    case types.GET_GROUP_STUDENTS_REQUEST:
      return {
        ...state,
        isFetchingGroupStudents: action.isFetchingGroupStudents
      };
    case types.GET_GROUP_STUDENTS_COMPLETED:
      return {
        ...state,
        isFetchingGroupStudents: action.isFetchingGroupStudents,
        groupStudents: action.groupStudents
      };
    case types.GET_GROUP_STUDENTS_ERROR:
      return {
        ...state,
        isFetchingGroupStudents: action.isFetchingGroupStudents,
        groupStudentsError: action.groupStudentsError
      };

    case types.GET_GROUP_PLAN_REQUEST:
      return {
        ...state,
        isFetchingGroupPlan: action.isFetchingGroupPlan
      };
    case types.GET_GROUP_PLAN_COMPLETED:
      return {
        ...state,
        isFetchingGroupPlan: action.isFetchingGroupPlan,
        groupPlan: action.groupPlan
      };
    case types.GET_GROUP_PLAN_ERROR:
      return {
        ...state,
        isFetchingGroupPlan: action.isFetchingGroupPlan,
        groupPlanError: action.groupPlanError
      };

    case types.GET_GROUP_PROGRAM_INFO_REQUEST:
      return {
        ...state,
        isFetchingGroupProgramInfo: action.isFetchingGroupProgramInfo
      };
    case types.GET_GROUP_PROGRAM_INFO_COMPLETED:
      return {
        ...state,
        isFetchingGroupProgramInfo: action.isFetchingGroupProgramInfo,
        groupProgramInfo: action.groupProgramInfo
      };
    case types.GET_GROUP_PROGRAM_INFO_ERROR:
      return {
        ...state,
        isFetchingGroupProgramInfo: action.isFetchingGroupProgramInfo,
        groupProgramInfoError: action.groupProgramInfoError
      };

    case types.CREATE_GROUP_REQUEST:
      return {
        ...state,
        isCreatingGroup: action.isCreatingGroup
      };
    case types.CREATE_GROUP_COMPLETED:
      return {
        ...state,
        isCreatingGroup: action.isCreatingGroup,
        createdGroup: action.createdGroup
      };
    case types.CREATE_GROUP_ERROR:
      return {
        ...state,
        isCreatingGroup: action.isCreatingGroup,
        groupCreationError: action.groupCreationError
      };

    case types.CREATE_NEW_STUDENT_REQUEST:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent
      };
    case types.CREATE_NEW_STUDENT_COMPLETED:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        createdStudent: action.createdStudent
      };
    case types.CREATE_NEW_STUDENT_ERROR:
      return {
        ...state,
        isCreatingStudent: action.isCreatingStudent,
        studentCreationError: action.studentCreationError
      };

    case types.ADD_EXIST_STUDENT_REQUEST:
      return {
        ...state,
        isAddingStudent: action.isAddingStudent
      };
    case types.ADD_EXIST_STUDENT_COMPLETED:
      return {
        ...state,
        isAddingStudent: action.isAddingStudent,
        addedStudent: action.addedStudent
      };
    case types.ADD_EXIST_STUDENT_ERROR:
      return {
        ...state,
        isAddingStudent: action.isAddingStudent,
        studentAdditionError: action.studentAdditionError
      };

    case types.MOVE_STUDENT_REQUEST:
      return {
        ...state,
        isMovingStudent: action.isMovingStudent
      };
    case types.MOVE_STUDENT_COMPLETED:
      return {
        ...state,
        isMovingStudent: action.isMovingStudent,
        movedStudent: action.movedStudent
      };
    case types.MOVE_STUDENT_ERROR:
      return {
        ...state,
        isMovingStudent: action.isMovingStudent,
        studentMovingError: action.studentMovingError
      };

    case types.DELETE_STUDENT_REQUEST:
      return {
        ...state,
        isDeletingStudent: action.isDeletingStudent
      };
    case types.DELETE_STUDENT_COMPLETED:
      return {
        ...state,
        isDeletingStudent: action.isDeletingStudent,
        deletedStudent: action.deletedStudent
      };
    case types.DELETE_STUDENT_ERROR:
      return {
        ...state,
        isDeletingStudent: action.isDeletingStudent,
        studentDeletingError: action.studentDeletingError
      };

    case types.GET_PLAN_LIST_REQUEST:
      return {
        ...state,
        isFetchingPlanList: action.isFetchingPlanList
      };
    case types.GET_PLAN_LIST_COMPLETED:
      return {
        ...state,
        isFetchingPlanList: action.isFetchingPlanList,
        planList: action.planList
      };
    case types.GET_PLAN_LIST_ERROR:
      return {
        ...state,
        isFetchingPlanList: action.isFetchingPlanList,
        planListError: action.planListError
      };

    case types.GET_ORG_TEACHER_LIST_REQUEST:
      return {
        ...state,
        isFetchingTeacherList: action.isFetchingTeacherList
      };
    case types.GET_ORG_TEACHER_LIST_COMPLETED:
      return {
        ...state,
        isFetchingTeacherList: action.isFetchingTeacherList,
        teacherList: action.teacherList
      };
    case types.GET_ORG_TEACHER_LIST_ERROR:
      return {
        ...state,
        isFetchingTeacherList: action.isFetchingTeacherList,
        teacherListError: action.teacherListError
      };

    case types.GET_GROUP_LIST_REQUEST:
      return {
        ...state,
        isFetchingGroupList: action.isFetchingGroupList
      };
    case types.GET_GROUP_LIST_COMPLETED:
      return {
        ...state,
        isFetchingGroupList: action.isFetchingGroupList,
        groupList: action.groupList
      };
    case types.GET_GROUP_LIST_ERROR:
      return {
        ...state,
        isFetchingGroupList: action.isFetchingGroupList,
        groupListError: action.groupListError
      };

    case types.UPLOAD_IMPORT_FILE_REQUEST:
      return {
        ...state,
        isUploadingFile: action.isUploadingFile
      };
    case types.UPLOAD_IMPORT_FILE_COMPLETED:
      return {
        ...state,
        isUploadingFile: action.isUploadingFile,
        uploadedFile: action.uploadedFile
      };
    case types.UPLOAD_IMPORT_FILE_ERROR:
      return {
        ...state,
        isUploadingFile: action.isUploadingFile,
        fileUploadError: action.fileUploadError
      };

    case types.CHECK_IMPORT_FILE_REQUEST:
      return {
        ...state,
        isCheckingFile: action.isCheckingFile
      };
    case types.CHECK_IMPORT_FILE_COMPLETED:
      return {
        ...state,
        isCheckingFile: action.isCheckingFile,
        checkedFile: action.checkedFile
      };
    case types.CHECK_IMPORT_FILE_ERROR:
      return {
        ...state,
        isCheckingFile: action.isCheckingFile,
        fileCheckingError: action.fileCheckingError
      };

    case types.EXEC_IMPORT_FILE_REQUEST:
      return {
        ...state,
        isExecutingFile: action.isExecutingFile
      };
    case types.EXEC_IMPORT_FILE_COMPLETED:
      return {
        ...state,
        isExecutingFile: action.isExecutingFile,
        executedFile: action.executedFile
      };
    case types.EXEC_IMPORT_FILE_ERROR:
      return {
        ...state,
        isExecutingFile: action.isExecutingFile,
        fileExecutingError: action.fileExecutingError
      };

    case types.UPDATE_GROUP_MAIN_REQUEST:
      return {
        ...state,
        isUpdatingGroup: action.isUpdatingGroup
      };
    case types.UPDATE_GROUP_MAIN_COMPLETED:
      return {
        ...state,
        isUpdatingGroup: action.isUpdatingGroup,
        updatingGroup: action.updatingGroup
      };
    case types.UPDATE_GROUP_MAIN_ERROR:
      return {
        ...state,
        isUpdatingGroup: action.isUpdatingGroup,
        updatingGroupError: action.updatingGroupError
	  };

	case types.GET_REQUEST_GROUP_REQUEST:
		return {
			...state,
			isFetchingRequestGroupList: action.isFetchingRequestGroupList
		};
		case types.GET_REQUEST_GROUP_COMPLETED:
		return {
			...state,
			isFetchingRequestGroupList: action.isFetchingRequestGroupList,
			requestGroupList: action.requestGroupList
		};
		case types.GET_REQUEST_GROUP_ERROR:
		return {
			...state,
      isFetchingRequestGroupList: action.isFetchingRequestGroupList,
			requestGroupListError: action.requestGroupListError
		};

    case types.CHANGE_STATE_GROUP_REQUEST:
      return {
        ...state,
        isChangingGroupStatus: action.isChangingGroupStatus
      };
    case types.CHANGE_STATE_GROUP_COMPLETED:
      return {
        ...state,
        isChangingGroupStatus: action.isChangingGroupStatus,
        changedGroupStatus: action.changedGroupStatus
      };
    case types.CHANGE_STATE_GROUP_ERROR:
      return {
        ...state,
        isChangingGroupStatus: action.isChangingGroupStatus,
        changingGroupStatusError: action.changingGroupStatusError
      };

    case types.DELETE_GROUP_REQUEST:
      return {
        ...state,
        isDeletingGroup: action.isDeletingGroup
      };
    case types.DELETE_GROUP_COMPLETED:
      return {
        ...state,
        isDeletingGroup: action.isDeletingGroup,
        deletedGroup: action.deletedGroup
      };
    case types.DELETE_GROUP_ERROR:
      return {
        ...state,
        isDeletingGroup: action.isDeletingGroup,
        deleteGroupError: action.deleteGroupError
      };

    default:
      return state;
  }
};
